import { createBrowserHistory } from 'history'
import { memo, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Route, Router, Switch } from 'react-router-dom'
import { FullLoader } from '../Components/LoaderBox/Loader'
import apiClient from '../Util/apiClient'

const InnerRoutes = FullLoader(() => import('./InnerRoutes'))
const PublicRoutes = FullLoader(() => import('./PublicRoutes'))

export const history = createBrowserHistory()

function Routes({ language = 'de', dispatch }) {
  const [init, setInit] = useState(false)

  useEffect(() => {
    setInit(true)
    apiClient.get(`translations/get-translations-by-language/${language}`).then(({ data }) => {
      if (data?.result) {
        dispatch({ type: 'SET_USER_REDUCER', payload: { translations: data?.result } })
      }
    })

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        dispatch({
          type: 'SET_USER_REDUCER',
          payload: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
        })
      })
    } else {
      console.log('Geolocation is not available in your browser.')
    }
  }, [])

  return (
    <Router history={history}>
      {init && (
        <Switch>
          <Route path="/app" component={InnerRoutes} />
          <Route path="/" component={PublicRoutes} />
        </Switch>
      )}
    </Router>
  )
}

export default memo(connect()(Routes))
